// The NIST calibration account. They add sensors in batches and the naming
// step errors out for them, so setup skips it and falls back to the sensor ID
// as the name (renameable afterwards from the sensor's settings).
export const NIST_ACCOUNT_EMAILS = new Set([
  "iso@tempstick.com"
]);

const normalize = email => {
  return email ? String(email).trim().toLowerCase() : '';
};

// Whether the session belongs to the NIST account. Sub users (and support /
// enterprise sessions) act on the parent account, so match on that email too.
export default function isNistAccount (user = window.currentUser) {

  if (!user) return false;

  const emails = [
    normalize(user.email),
    normalize(user.sub_user && user.sub_user.parent ? user.sub_user.parent.email : '')
  ];

  return emails.some(email => email.length > 0 && NIST_ACCOUNT_EMAILS.has(email));

}
